import type { DestinationType } from '../../../types';

/** Keeps the user's selected destination after the saved destination is applied once. */
export function resolveDestinationType(
  hasAppliedSavedDestinationType: boolean,
  destinationType: DestinationType,
  savedDestinationType: DestinationType | undefined
): DestinationType {
  if (hasAppliedSavedDestinationType) {
    return destinationType;
  }

  return savedDestinationType ?? destinationType;
}